module.exports = {
	"id": "NI",
	"name": "Nicaragua",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.038962,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.02783,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.016698,
			"23": 0.005566,
			"24": null,
			"25": null,
			"26": 0.02783,
			"27": 0.011132,
			"28": null,
			"29": 0.022264,
			"30": 0.005566,
			"31": 0.072358,
			"32": 0.011132,
			"33": 0.016698,
			"34": 0.016698,
			"35": 0.038962,
			"36": 0.02783,
			"37": 0.038962,
			"38": 0.044528,
			"39": 0.050094,
			"40": 0.050094,
			"41": 0.022264,
			"42": 0.033396,
			"43": 0.133584,
			"44": 0.061226,
			"45": 0.116886,
			"46": 0.089056,
			"47": 0.172546,
			"48": 0.161414,
			"49": 1.513952,
			"50": 0.133584,
			"51": 0.50094,
			"52": 0.562166,
			"53": 26.41067,
			"54": 7.5141,
			"55": 0.077924,
			"56": 0.016698,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.016698,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.005566,
			"12": 0.005566,
			"13": null,
			"14": 0.022264,
			"15": null,
			"16": null,
			"17": 0.005566,
			"18": null,
			"19": null,
			"20": 0.022264,
			"21": 0.005566,
			"22": 0.016698,
			"23": null,
			"24": 0.005566,
			"25": 0.011132,
			"26": 0.011132,
			"27": null,
			"28": null,
			"29": 0.011132,
			"30": 0.016698,
			"31": 0.016698,
			"32": 0.011132,
			"33": 0.022264,
			"34": 0.011132,
			"35": 0.022264,
			"36": 0.033396,
			"37": 0.02783,
			"38": 0.077924,
			"39": 0.061226,
			"40": 0.05566,
			"41": 0.050094,
			"42": 0.061226,
			"43": 0.267168,
			"44": 0.061226,
			"45": 0.300564,
			"46": 0.089056,
			"47": 0.534336,
			"48": 0.41745,
			"49": 5.06506,
			"50": 0.050094,
			"51": 0.011132,
			"52": null,
			"3.5": null,
			"3.6": 0.011132
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.011132,
			"28": null,
			"29": 0.228206,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.044528,
			"34": null,
			"35": 0.011132,
			"36": 0.016698,
			"37": 0.272734,
			"38": 0.016698,
			"39": 0.011132,
			"40": 0.33396,
			"41": 0.050094,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.011132
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.011132,
			"6": 0.011132,
			"7": null,
			"8": 0.094622,
			"9": 0.11132,
			"10": 0.36179,
			"3.1": null,
			"3.2": null,
			"5.1": 0.016698,
			"6.1": 0.022264,
			"7.1": 0.011132,
			"9.1": 0.356224
		},
		"ios_saf": {
			"8": 0,
			"10": 1.76671475354,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0476109182973,
			"8.1-8.4": 0.0879591541424,
			"9.0-9.2": 0.0419621652789,
			"9.3": 0.640192008743
		},
		"android": {
			"3": 0,
			"4": 0.121077028424,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.015134628553,
			"4.1": 0.436742138243,
			"4.2-4.3": 1.09185534561,
			"4.4": 2.50369998062,
			"4.4.3-4.4.4": 2.52532087855
		},
		"ie": {
			"6": 0.00569282025316,
			"7": 0.00569282025316,
			"8": 0.278948192405,
			"9": 0.176477427848,
			"10": 0.199248708861,
			"11": 1.58260403038,
			"5.5": null
		},
		"op_mob": {
			"0": 0.347899580394,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00966387723317
		},
		"edge": {
			"12": 0.122452,
			"13": 0.233772,
			"14": 0.339526
		},
		"ie_mob": {
			"10": 0.220276394366,
			"11": 0.896839605634
		},
		"bb": {
			"7": 0.057629,
			"10": null
		},
		"samsung": {
			"0": 3.377946
		},
		"and_uc": {
			"0": 1.485055
		},
		"op_mini": {
			"0": 4.68719054237
		},
		"and_chr": {
			"0": 28.012721
		},
		"and_ff": {
			"0": 0.031031
		}
	},
	"total": 98.810217
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NI.json
 ** module id = 609
 ** module chunks = 0
 **/